import { gatewayClient, createService } from './connectors/httpClient';
import { gatewayStream } from './connectors/sseClient';
import { ExportJobItemType } from 'packages/variation-export/AllExports/types';

const httpClient = gatewayClient('/exports');
const progressStream = gatewayStream('/exports');

const exportService = createService(httpClient, (client) => ({
    getActivityFeedItems(data) {
        const searchParams = new URLSearchParams(data);

        if (searchParams.has('search')) {
            searchParams.set('query', searchParams.get('search'));
            searchParams.delete('search');
        }

        return client.get<{ items: ExportJobItemType[]; totalItems: number; message?: string }>(
            `?${searchParams.toString()}`,
        );
    },

    deleteFailedExportJob(jobId): Promise<{ status: number; json: { message?: string } }> {
        return client.delete(`/${jobId}`);
    },

    createExportJob(data) {
        return client.put<{ id: number }>('', data);
    },
}));

// The stream sends `new ExportJobVariationDto(progress, status)`: no id, no variation, no updated.
export type ExportJobVariationProgress = {
    status: string;
    progress: number;
};

// Optional so a handler written against either transport's payload stays assignable to the other.
// `created` is never sent: mapToProgressFields builds a fresh DTO.
export type ExportJobProgressItem = Pick<
    ExportJobItemType,
    'id' | 'name' | 'type' | 'updated' | 'totalVariationsCount' | 'progresses'
> & {
    jobVariations: ExportJobVariationProgress[];
    creativeName?: string;
    progress?: number;
    isCompleted?: boolean;
    isFailed?: boolean;
};

export type ExportJobProgressPayload = {
    totalItems: number;
    items: ExportJobProgressItem[];
};

export function listenToExportJobProgress(
    exportJobId: number,
    onData: (data: ExportJobProgressPayload) => void,
    onClose?: () => void,
): () => void {
    return progressStream.subscribe<ExportJobProgressPayload>(`/${exportJobId}/progress/stream`, {
        eventName: 'progress',
        onMessage: (data) => onData(data),
        onClose,
    });
}

export default exportService;
